import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/pathObj'
import OButton from 'components/reusable/OButton'
import dayjs from 'dayjs'
import Pagination from '../Pagination'
import AuthContext from 'context/AuthContext'
import { useTranslation } from 'react-i18next'
import DepartmentList from './DepartmentList'
import DepartmentAdd from './DepartmentAdd'
import DepartmentEdit from './DepartmentEdit'
import helpers from 'utils/helpers'
import OSearch from 'components/reusable/OSearch'

const DepartmentManager = () => {
  const { updatePageName } = useContext(AuthContext)
  const { t } = useTranslation()
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const [departmentList, setDepartmentList] = useState([])
  const [departmentAdd, setDepartmentAdd] = useState(false)
  const [departmentEdit, setDepartmentEdit] = useState(false)
  const [currentItem, setCurrentItem] = useState('')
  const [searchTerm, setSearchTerm] = useState('')
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('')
  const [isInitialized, setIsInitialized] = useState(false)
  const [filterData, setFilterData] = useState({
    category: '',
    searchKey: '',
    startDate: '',
    endDate: '',
    isReset: false,
    isFilter: false
  })
  const [sort, setSort] = useState({
    sortBy: 'createdAt',
    sortType: 'desc'
  })

  const handleEdit = item => {
    setCurrentItem(item)
    setDepartmentEdit(!departmentEdit)
  }
  const handleCategory = () => {
    setDepartmentAdd(!departmentAdd)
  }

  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  const allDepartment = async data => {
    try {
      const { category, startDate, endDate, searchKey, isFilter } = filterData
      if (
        (data?.deletePage && departmentList?.length >= 1) ||
        (isFilter &&
          category &&
          data?.statusChange &&
          departmentList?.length >= 1)
      ) {
        setPage(page - 1)
        setPaginationObj({ ...paginationObj, page: page - 1 })
      }

      const payload = {
        page,
        pageSize,
        status: category,
        startDate: helpers?.ternaryCondition(
          startDate,
          dayjs(startDate).format('YYYY-MM-DD'),
          null
        ),
        endDate: helpers?.ternaryCondition(
          endDate,
          dayjs(endDate).format('YYYY-MM-DD'),
          null
        ),
        keyword: searchKey,
        sortBy: sort.sortBy,
        sortType: sort.sortType
      }
      const path = apiPath.departmentList
      const result = await apiGet(path, payload)
      const response = result?.data?.results
      const resultStatus = result?.data?.success
      setDepartmentList(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: helpers?.ternaryCondition(resultStatus, response.page, null),
        pageCount: helpers?.ternaryCondition(
          resultStatus,
          response.totalPages,
          null
        ),
        perPageItem: helpers?.ternaryCondition(
          resultStatus,
          response?.docs.length,
          null
        ),
        totalItems: helpers?.ternaryCondition(
          resultStatus,
          response.totalDocs,
          null
        )
      })
    } catch (error) {
      console.log('error in get all country list==>>>>', error.message)
    }
  }

  useEffect(() => {
    allDepartment()
  }, [page, filterData, sort])

  const handleReset = () => {
    setFilterData({
      category: '',
      searchKey: '',
      startDate: '',
      endDate: '',
      isReset: true,
      isFilter: false
    })
    setPage(1)
    setSearchTerm('')
  }

  const statusPage = e => {
    setFilterData({
      ...filterData,
      isReset: false,
      category: e.target.value,
      isFilter: true
    })
    setPage(1)
  }

  const handleDateChange = e => {
    const { name, value } = e.target
    setFilterData(prev => ({
      ...prev,
      [name]: value,
      isReset: false,
      isFilter: true
    }))
    setPage(1)
  }

  useEffect(() => {
    helpers.setDebouncingFunction({
      isInitialized,
      setIsInitialized,
      debouncedSearchTerm,
      searchTerm,
      filterData,
      setFilterData,
      setPage
    })
  }, [debouncedSearchTerm])

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm)
    }, 500)
    return () => {
      clearTimeout(timeoutId)
    }
  }, [searchTerm])

  useEffect(() => {
    updatePageName(t('DEPARTMENT_MANAGER'))
  }, [])

  return (
    <>
      {' '}
      <div className='bg-[#F9F9F9]'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] rounded-lg'>
            <form className='border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3'>
              <div className='col-span-2 flex flex-wrap  items-center mb-2 2xl:mb-0'>
                <div className='flex items-center lg:pt-0 pt-3 flex-wrap '>
                  <div className='relative flex items-center mb-3'>
                    <OSearch
                      setSearchTerm={setSearchTerm}
                      searchTerm={searchTerm}
                      placeholder={t('SEARCH_BY_DEPARTMENT')}
                    />
                  </div>
                  <div className='flex items-center  ml-3 mb-3'>
                    <select
                      id=''
                      type='text '
                      name='category'
                      className='block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                      placeholder=' '
                      onChange={e => statusPage(e)}
                      value={filterData?.category}
                    >
                      <option value=''>
                        {t('O_ALL')}
                      </option>
                      <option value='active'>{t('O_ACTIVE')}</option>
                      <option value='inactive'>{t('O_INACTIVE')}</option>
                    </select>

                    <input
                      type='date'
                      name='startDate'
                      value={filterData.startDate}
                      onChange={handleDateChange}
                      className='block p-2 ml-1 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                    />
                    <input
                      type='date'
                      name='endDate'
                      value={filterData.endDate}
                      onChange={handleDateChange}
                      className='block p-2 ml-1 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                    />
                  </div>
                  <OButton
                    label='Reset'
                    type='button'
                    onClick={handleReset}
                    extraClasses='ml-3 mb-3'
                    style={{ borderRadius: '0.5rem' }}
                  />
                </div>
              </div>
              <div className='flex items-center justify-end px-4 ms-auto mb-3'>
                <button
                  title='Add department'
                  type='button'
                  className='bg-LightBlue flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue whitespace-nowrap'
                  onClick={() => handleCategory()}
                >
                  + {t('ADD_DEPARTMENT')}
                </button>
              </div>
            </form>
            <DepartmentList
              departmentList={departmentList}
              allDepartment={allDepartment}
              page={page}
              handleEdit={handleEdit}
              currentItem={currentItem}
              setSort={setSort}
              sort={sort}
            />
            {departmentEdit && (
              <DepartmentEdit
                handleEdit={handleEdit}
                currentItem={currentItem}
                allDepartment={allDepartment}
              />
            )}

            {departmentAdd && (
              <DepartmentAdd
                allDepartment={allDepartment}
                departmentAdd={departmentAdd}
                handleCategory={handleCategory}
                setPage={setPage}
              />
            )}
            {paginationObj?.totalItems ? (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                page={page}
              />
            ) : null}
          </div>
        </div>
      </div>
    </>
  )
}

export default DepartmentManager
